/* tslint:disable max-line-length */
import { Component, OnInit, AfterViewInit, Renderer2, Inject, Input } from '@angular/core';
import { TableData } from 'src/app/shared/models/tableData';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ToolSettingsService } from 'src/app/service/tool-settings/tool-settings.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { ToolPermissionsService } from 'src/app/service/auth/tool-permissions.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-tool-transfer-list',
  templateUrl: './tool-transfer-list.component.html',
  styleUrls: ['./tool-transfer-list.component.scss'],
})
export class ToolTransferListComponent implements OnInit, AfterViewInit {
  filterType;
  constructor(
    private toolSettingsService: ToolSettingsService,
    /* tslint:disable-next-line variable-name */
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    private toolPermissionsService: ToolPermissionsService,
    private loaderService: LoaderService,
  ) {
    // Fetch options for all assignment filters (assignedBy,assignedTo,assignedFrom)
    this.loadOptions('assignmentFiltersNames');
  }

  ngOnInit(): void {
    this.loaderService.displayLoader();
  }

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  data: TableData = {
    label: 'Transfer',
    type: 'transfers',
    editAccess: true,
    statusToggle: false,
    columns: [
      {
        name: 'batchId',
        label: 'Batch Number',
        property: row => (row.assignment?.batchId === 0 ? '0' : row.assignment?.batchId),
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedDate',
        label: 'Last Assigned',
        property: row => row.assignment?.assignedDate,
        sortable: true,
        columnStyles: { 'max-width': '210px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '10rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'toolId',
        label: 'Tool ID',
        property: row => row.assignment?.tool?.toolId,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': true },
        show: row => {
          return this.toolPermissionsService.isAllowed(row, 'tools', 'detailed_view');
        },
        link: row => {
          return [`/tools/edit/${row.assignment?.tool.id}`];
        },
      },
      {
        name: 'toolDescription',
        label: 'Tool Name',
        property: row => row.assignment?.tool?.model?.name,
        columnStyles: { 'max-width': '120px' },
        headerStyles: { 'min-width': '9rem' },
        sortable: true,
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'category',
        label: 'Category',
        property: row => row.assignment?.tool?.model?.category?.name,
        sortable: true,
        columnStyles: { 'min-width': '100px', 'max-width': '7%', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedFrom',
        label: 'Transfer From',
        property: row => row?.assignedFrom,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '5rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedTo',
        label: 'Assigned To',
        property: row => row?.assignedTo,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '12rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'responsibleParty',
        label: 'Responsible Party',
        property: row => row.assignment?.responsibleParty?.employeeAlias,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedBy',
        label: 'Transfer By',
        property: row => row?.assignedBy,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'transferNotes',
        label: 'Transfer Notes',
        property: row => row.assignment?.notes,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '8rem' },
      },
    ],
    rowActions: [],
    data: [],
    pagination: {},
    meta: {},
  };
  dialogRecord: any = {};

  get attributes() {
    const attributes = [
      'id',
      'batchId',
      'assignedDate',
      'toolId',
      'toolDescription',
      'category',
      'serialNumber',
      'assignedTo',
      'responsibleParty',
      'responsibleParty',
      'transferNotes',
      'model.id|name',
      'assignment.id|assignedDate|primaryAssignment|notes',
      'alert.id|message|enabled',
    ];
    return attributes.join(',');
  }

  get searchFields() {
    const fields = ['assignment.tool.model.name', 'assignment.notes', 'assignment.tool.model.category.name'];
    return fields.join(',');
  }

  getUniqueOptionsNoSort(options: Record<string, unknown>[], filter) {
    return options
      .filter((v, i, a) => {
        if (Object.keys(v).includes('assignedTo') && !v?.assignedTo) return false

        return a.findIndex(v2 => v2[filter.name] === v[filter.name]) === i
      });
  }

  // TODO: Types for API response
  loadAssignmentFilterOptions(data: unknown[]) {
    const filters = this.filters.filter(f => f.assignment);

    filters.forEach(filter => {
      //Custom options list formed here for assignment filters
      //Creates unique list of options and sorts ASC

      const options = data.map(d => ({
        [filter.name]: d[filter.name],
        [filter.value]: {
          [filter.value]: d[filter.value],
          [`${filter.name}PropertyType`]: d[`${filter.name}PropertyType`],
        },
      }));

      filter.options = this.getUniqueOptionsNoSort(options, filter);
    });
  }

  loadOptions(key: string): void {
    if (!key) return;

    // loop through modelDetails object and capture information from API
    // call the API for this endpoint 'key' and store result in modelDetail[key]
    this.toolSettingsService.read[key]().subscribe(
      res => {
        this.loaderService.hideLoader();

        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});

        this.modelDetail[key] = settings;

        // establish the list of options for the select elements
        if (['assignmentFilters', 'assignmentFiltersNames'].includes(key)) {
          this.loadAssignmentFilterOptions(res.data);
        } else {
          const filter = this.filters.find(f => f.model === key);
          filter.options = res.data;
        }
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }
  filters: Array<any> = [
    {
      label: 'Tool ID',
      type: 'select2',
      propertyName: 'scope[tool]',
      default: '',
      value: 'id',
      name: 'toolId',
      model: 'tools',
      options: [],
      loadOptions: () => this.loadOptions('tools'),
    },
    {
      label: 'Category',
      type: 'select2',
      propertyName: 'scope[category]',
      default: '',
      value: 'id',
      name: 'name',
      model: 'categories',
      options: [],
      loadOptions: () => this.loadOptions('categories'),
    },
    {
      label: 'Transfer From',
      type: 'select2',
      propertyName: 'assignmentFilter[assignedFrom]',
      propertyType: '',
      default: '',
      value: 'assignedFromId',
      name: 'assignedFrom',
      model: 'assignedFrom',
      assignment: true,
      options: [],
      loadOptions: () => undefined,
    },
    {
      label: 'Transfer By',
      type: 'select2',
      propertyName: 'assignmentFilter[assignedBy]',
      default: '',
      value: 'assignedById',
      name: 'assignedBy',
      model: 'assignedBy',
      assignment: true,
      options: [],
      loadOptions: () => undefined,
    },
    {
      label: 'Batch Number',
      type: 'select2',
      propertyName: 'scope[batchId]',
      default: '',
      value: 'batchId',
      name: 'batchId',
      model: 'batchId',
      options: [],
      loadOptions: () => this.loadOptions('batchId'),
    },
    {
      label: 'Assigned To',
      type: 'select2',
      propertyName: 'assignmentFilter[assignedTo]',
      propertyType: '',
      default: '',
      value: 'assignedToId',
      name: 'assignedTo',
      model: 'assignedTo',
      assignment: true,
      options: [],
      loadOptions: () => undefined,
    },
    {
      label: 'Assignment Date Range',
      type: 'date-range',
      propertyName: 'scope[assignedDateRange]',
      default: '',
      value: '',
      name: 'assignedDate',
      model: 'assignment',
      options: [],
      loadOptions: () => undefined, //options fetched on init
    },
  ];
  searchParams: ToolSearchParams = {
    page: 1,
    limit: 50,
    order: 'batchId,desc',
    embed: 'assignment',
    searchFields: this.searchFields,
  };
  exportEmbedGroups = {
    default: 'assignment',
  };
  toolTransferExportParams: ToolSearchParams = {
    embed: this.exportEmbedGroups['default'],
  };
  get exportAttributes() {
    const attributes = [
      'toolId',
      'initialMileageHours',
      'description',
      'serialNumber',
      'lastMileageHours',
      'model.manufacturer.name',
      'model.category.name',
      'model.category.assetClass.name',
      'notes',
      'purchDate',
      'purchPrice',
      'initialMileageHours',
    ];
    return attributes.join(',');
  }
  get exportFields() {
    const fields = [
      'toolId',
      'description',
      'serialNumber',
      'lastMileageHours',
      'model.manufacturer.name',
      'model.category.name',
      'model.category.assetClass.name',
      'vehicleDetail.license_plate',
      'notes',
      'assignment.assigned_to',
      'assignment.notes',
      'assignment.type.name',
      'assignment.assigned_date',
      'assignment.job.name',
      'assignment.owner.id',
      'assignment.vendor.company_name',
      'assignment.employee.employee_alias',
      'assignment.responsibleParty.employee_alias',
    ];
    return fields.join(',');
  }
}
